import { Badge } from '@/components/ui/badge';
import { T } from 'gt-react';
import { LockSimple } from '@phosphor-icons/react';

/**
 * Shown on AR records that were synced from an external system (Famous, Plaid,
 * inbound email). These are read-only in the UI — the next sync would clobber
 * any in-app edit — so create/edit controls are hidden and this badge explains
 * why. Records with `originSystem === "manual"` are editable and omit it.
 */
export function OriginReadOnlyBadge({ className }: { className?: string }) {
  return (
    <Badge variant="outline" className={className}>
      <LockSimple className="mr-1 size-3" weight="bold" />
      <T context="badge, record synced from external system is read-only">
        Synced · read-only
      </T>
    </Badge>
  );
}

/** Convenience predicate mirroring the backend `isManualOrigin` guard. */
export function isManualOrigin(
  originSystem: string | null | undefined,
): boolean {
  return originSystem === 'manual';
}
